module.exports = __webpack_public_path__ + "img/about_friend.02f9859c.png";